module.exports = __webpack_public_path__ + "static/media/iconcoachingcall-grey.e229a955.svg";